export const CZECHIA_BOUNDS = {
  south: 48.55,
  west: 12.09,
  north: 51.06,
  east: 18.87,
}

const cleanValues = (values = []) => values.map((value) => String(value || '').trim()).filter(Boolean)

export const isWholeCountrySelection = ({ region, municipalities = [], districts = [] }) =>
  String(region || '').toLowerCase() === 'all' && municipalities.length === 0 && districts.length === 0

export const getViewportQueries = ({ region, regionLabel = region, municipalities = [], districts = [] }) => {
  const selectedMunicipalities = cleanValues(municipalities)
  const selectedDistricts = cleanValues(districts)

  if (selectedDistricts.length > 0) {
    const municipality = selectedMunicipalities.length === 1
      ? selectedMunicipalities[0]
      : ['Brno', 'Ostrava'].includes(regionLabel) ? regionLabel : null

    return selectedDistricts.map((district) => [district, municipality, 'Česko'].filter(Boolean).join(', '))
  }

  if (selectedMunicipalities.length > 0) {
    return selectedMunicipalities.map((municipality) => `${municipality}, Česko`)
  }

  if (String(region || '').toLowerCase() === 'all') return []
  return [`${regionLabel}, Česko`]
}
